<!--Kent: Make links responsive:-->
<!--<header class="top">
  <div class="wrap">
	<a href="#top" aria-label="The Energy Professor home"><img src="assets/logo.png" alt="The Energy Professor" /></a>
	<nav class="links">
	  <a href="#services">Services</a>
	  <a href="#report">Reports</a>
	  <a href="#about">About</a>
	  <a href="#watch">Watch</a>
	  <a href="#" class="nav-cta donate" (click)="donate($event)">Donate</a>
	  <a href="#request" class="nav-cta">Request</a>
	</nav>
  </div>
</header>-->
<header class="top">
	<div class="wrap">

		<!-- Logo -->
		<a href="#top" aria-label="The Energy Professor home">
			<img src="assets/logo.png" alt="The Energy Professor" />
		</a>

		<!-- Desktop nav -->
		<nav class="desktop-nav">
			<a href="#services">Services</a>
			<a href="#report">Reports</a>
			<a href="#about">About</a>
			<a href="#watch">Watch</a>
		</nav>

		<!-- CTA + Hamburger -->
		<div class="right">
			<a href="#request" class="nav-cta">Request</a>

			<button class="hamburger"
					type="button"
					aria-label="Toggle menu"
					(click)="toggleMenu()">

				<span></span>
				<span></span>
				<span></span>

			</button>
		</div>

	</div>
</header>

<div class="backdrop" *ngIf="menuOpen" (click)="closeMenu()"></div>



<!-- Mobile menu -->
<nav class="mobile-menu" [class.open]="menuOpen">
	<a href="#services" (click)="closeMenu()">Services</a>
	<a href="#report" (click)="closeMenu()">Reports</a>
	<a href="#about" (click)="closeMenu()">About</a>
	<a href="#watch" (click)="closeMenu()">Watch</a>
</nav>




<!-- HERO: rotating reports banner -->
<section class="hero" id="top">
	<div class="epb" id="epbBanner" (mouseenter)="stop()" (mouseleave)="startRotation()">
		<div class="epb-inner">
			<p class="epb-eyebrow">The reports &nbsp;&middot;&nbsp; <b>free, independent infrastructure intelligence</b></p>
			<button class="epb-nav epb-prev" aria-label="Previous report" (click)="prev()">&#8249;</button>
			<button class="epb-nav epb-next" aria-label="Next report" (click)="next()">&#8250;</button>
			<div class="epb-vp">
				<div class="epb-slide" *ngFor="let r of slides; let i = index" [class.on]="i === activeSlide">
					<div class="epb-cover"><img [src]="r.coverImage" [alt]="r.title + ' cover'"></div>
					<div class="epb-meta">
						<span class="epb-pill">{{ i === 0 ? 'Flagship report' : 'Available now' }}</span>
						<h3>{{ r.title }}</h3>
						<p class="epb-desc">{{ r.descriptor }}</p>
						<p class="epb-tag">{{ r.tagline }}</p>
						<div class="epb-cta">
							<button type="button" class="epb-btn primary" (click)="selectReport(r.title)">Request the report</button>
							<a class="epb-btn ghost" href="#reportsPick">See all reports</a>
						</div>
					</div>
				</div>
			</div>
			<div class="epb-dots">
				<button class="epb-dot" *ngFor="let r of slides; let i = index" [class.on]="i === activeSlide"
						[attr.aria-label]="'Go to report ' + (i + 1)" (click)="go(i)"></button>
			</div>
		</div>
	</div>
</section>

<!-- SERVICES -->
<section id="services">
	<div class="wrap">
		<div class="head">
			<p class="eyebrow">Work with me</p>
			<h2>Engage the Energy Professor</h2>
			<p style="max-width:760px;margin-top:12px;color:var(--muted);font-size:17px;line-height:1.6">Independent intelligence, education and advisory for the people building power and infrastructure. The reports are free. These are the ways to go further together.</p>
		</div>

		<div class="svc-fam" *ngFor="let group of content?.serviceGroups">
			<p class="eyebrow">{{ group.name }}</p>
			<div class="svc-grid">
				<div class="scard" *ngFor="let s of group.items">
					<h4>{{ s.name }}</h4>
					<p>{{ s.description }}</p>
					<button class="inq" (click)="inquire(s.name)">{{ s.cta || 'Inquire' }} &rsaquo;</button>
					<a class="btn pay" *ngIf="s.stripeLink as link" [href]="link" target="_blank" rel="noopener" (click)="analytics.track('service_pay', s.name)">Book and pay</a>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- PATH CTA -->
<div class="path-cta">
	<div class="wrap">
		<div class="cta-row">
			<a href="#services" class="btn">Work with me</a>
			<a href="#report" class="btn ghost">Read the reports</a>
		</div>
	</div>
</div>

<!-- REPORT -->
<section id="report">
	<div class="wrap">
		<div class="report-intro">
			<p class="eyebrow">The Energy Professor &nbsp; <span class="red">Market Intelligence</span></p>
			<hr class="rule" />
			<h2 class="gap-h">The gap nobody sees</h2>
			<p class="lede">The hidden bottleneck behind power, utilities and data center projects. The danger is rarely the gap everyone can see. It is the one that stays invisible from inside a single lane until it stops a project.</p>
			<div class="thesis">
				<p>Infrastructure commercialization is the work of moving land, power, equipment, capital and stakeholders into assets that are energized, operating and producing.</p>
			</div>
		</div>

		<ng-container *ngIf="featured as f">
			<div class="head">
				<p class="eyebrow">Featured report</p>
				<h2>{{ f.title }}</h2>
				<span class="badge available" style="margin-top:14px">Available now</span>
			</div>
			<div class="report-grid">
				<div>
					<p class="meta">Executive Market Intelligence Assessment</p>
					<p class="body">The story across energy infrastructure is usually told as a labor story. The more accurate story is structural. Infrastructure work is converging faster than organizations, hiring systems and industry language can adapt. The binding constraint on most projects is no longer a missing technical solution. It is coordination across physical, commercial, regulatory and institutional realities that answer to different owners, incentives and clocks.</p>
					<ul class="findings">
						<li *ngFor="let item of f.findings; let i = index"><span class="n">{{ (i + 1) | number: '2.0' }}</span><span class="t">{{ item }}</span></li>
					</ul>
					<p class="audience">Prepared for circulation among executives, infrastructure investors, utility and data center leadership, executive search and board members. The findings describe a market pattern and reference no individual.</p>
				</div>
				<aside class="cover">
					<p class="tag">The Energy Professor</p>
					<h3>{{ f.title }}</h3>
					<div class="cdash"></div>
					<p class="sub">A market intelligence assessment of the critical gaps that become costly setbacks when left unseen.</p>
					<a href="#request" class="btn">Request the report</a>
					<p class="ver">Version {{ f.version || '1.0' }} &middot; June 2026</p>
				</aside>
			</div>
		</ng-container>

		<div class="lib">
			<p class="eyebrow">The full library</p>
			<h3 class="lib-h">Every report in the series</h3>
			<div class="lib-grid">
				<div class="lib-card" *ngFor="let r of content?.reports">
					<img class="thumb" [src]="r.thumbnailImage" [alt]="r.title">
					<div class="lib-body">
						<span class="lib-badge" [class.avail]="isAvailable(r)" [class.soon]="!isAvailable(r)">{{ badge(r) }}</span>
						<h4>{{ r.title }}</h4>
						<p class="lib-tag">{{ r.tagline }}</p>
						<button class="lib-link req" [class.soon]="!isAvailable(r)" (click)="selectReport(r.title)">
							{{ isAvailable(r) ? 'Request the report' : 'Request early access' }} &rsaquo;
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ABOUT -->
<section class="alt" id="about">
	<div class="wrap">
		<div class="head">
			<p class="eyebrow">About</p>
			<h2>Reporting from the boundaries</h2>
			<hr class="rule" />
		</div>
		<p style="max-width:64ch;font-size:18px;color:#33373d;margin:0">The Energy Professor is an independent infrastructure intelligence initiative focused on power, utilities, large-load development, manufacturing, data centers and critical infrastructure. The pattern in this work becomes visible only from a position that touches several lanes at once and watches the same coordination gaps recur in each. The objective is not consensus. It is understanding. The infrastructure challenges ahead are too complex to be solved from a single point of view.</p>

		<p style="font-size: 16px; line-height: 1.62;">For questions, engagement inquiries or verification, reach The Energy Professor directly.</p>
		<dl style="display: block; margin-block-start: 1em; margin-block-end: 1em; unicode-bidi: isolate;">
			<dt style="font-family: Archivo; font-weight: 800; font-size: 12px; text-transform: uppercase; letter-spacing: .06em; color: var(--muted); margin-top: 12px;">Email</dt>
			<dd style="margin: 2px 0 0; font-size: 18px;">talk&#64;theenergyprofessor.net</dd>
			<dt style="font-family: Archivo; font-weight: 800; font-size: 12px; text-transform: uppercase; letter-spacing: .06em; color: var(--muted); margin-top: 12px;">Phone</dt>
			<dd style="margin: 2px 0 0; font-size: 18px;">(214) 356 7130</dd>
			<dt style="font-family: Archivo; font-weight: 800; font-size: 12px; text-transform: uppercase; letter-spacing: .06em; color: var(--muted); margin-top: 12px;">Business hours</dt>
			<dd style="margin: 2px 0 0; font-size: 18px;">Monday to Friday, 9 to 5 Central</dd>
		</dl>
	</div>
</section>

<!-- WATCH -->
<section id="watch">
	<div class="wrap">
		<div class="head">
			<p class="eyebrow">Watch</p>
			<h2>Power talks</h2>
		</div>
		<div class="watch-card" *ngIf="!videoUrl">
			<div class="play" aria-hidden="true">
				<svg viewBox="0 0 24 24" fill="#fff"><path d="M8 5v14l11-7z" /></svg>
			</div>
			<div>
				<h3>The Energy Professor on YouTube</h3>
				<p>Conversations at the boundaries between disciplines, where the most useful thinking tends to happen. Interviews, working sessions and plain-language briefings on the systems shaping infrastructure.</p>
				<a class="btn" href="https://www.youtube.com/&#64;energyprofessor8033" target="_blank" rel="noopener">Visit the channel</a>
			</div>
		</div>
		<div style="margin-top:32px;max-width:840px" *ngIf="videoUrl">
			<div style="position:relative;padding-top:56.25%;border-radius:4px;overflow:hidden;border:1px solid var(--line)">
				<iframe style="position:absolute;inset:0;width:100%;height:100%" [src]="videoUrl" title="The Energy Professor" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			</div>
		</div>
	</div>
</section>

<!-- REQUEST -->
<section class="alt" id="request">
	<div class="wrap">
		<div class="head">
			<p class="eyebrow">Request</p>
			<h2>Tell me where you sit</h2>
		</div>
		<div class="form-intro">
			<p class="lede">Request a report, or start a conversation about a service. Add your vantage point if you would like. The most useful conversations happen across lanes, not inside them.</p>
		</div>
		<div class="form-grid">

			<!--Kent: Make required fields required-->
			<!--<form id="reportForm" novalidate (ngSubmit)="submit()" *ngIf="!submitted">-->
			<!--<form #f="ngForm" novalidate (ngSubmit)="submit(f)" *ngIf="!submitted">-->
			<form #f="ngForm" id="reportForm" (ngSubmit)="submit(f)" *ngIf="!submitted">

				<div id="intentChip" class="intent-chip" *ngIf="intent" style="display:flex">
					<span>Inquiring about: <strong>{{ intent }}</strong></span>
					<button type="button" aria-label="Clear selection" (click)="clearIntent()">&times;</button>
				</div>
				<div class="field">
					<label for="name">Full name</label>
					<input id="name" type="text" required [(ngModel)]="form.name" name="name" #nameCtrl="ngModel" />
					<div class="error" *ngIf="nameCtrl.invalid && nameCtrl.touched">
						Full name is required
					</div>
				</div>
				<div class="field">
					<label for="org">Organization</label>
					<input id="org" type="text" autocomplete="organization" required [(ngModel)]="form.org" name="org" #orgCtrl="ngModel" />
					<div class="error" *ngIf="orgCtrl.invalid && orgCtrl.touched">
						Organization is required
					</div>
				</div>
				<div class="field">
					<label for="lane">Your lane</label>
					<select id="lane" required [(ngModel)]="form.lane" name="lane" #laneCtrl="ngModel">
						<option value="" disabled selected>Select one</option>
						<option>Utility or cooperative</option>
						<option>Developer</option>
						<option>OEM or equipment</option>
						<option>Investor or capital</option>
						<option>Recruiter or search</option>
						<option>Consumer</option>
						<option>Other</option>
					</select>
					<div class="error" *ngIf="laneCtrl.invalid && laneCtrl.touched">
						Lane is required
					</div>
				</div>
				<div class="field">
					<label for="email">Email</label>
					<input id="email" type="email" autocomplete="email" required [(ngModel)]="form.email" name="email" #emailCtrl="ngModel" />
					<div class="error" *ngIf="emailCtrl.invalid && emailCtrl.touched">
						Email is required
					</div>
				</div>
				<div class="field">
					<label for="phone">Phone <span class="opt">(optional)</span></label>
					<input id="phone" type="tel" autocomplete="tel" [(ngModel)]="form.phone" [ngModelOptions]="{standalone:true}" />
				</div>
				<div class="field">
					<label for="note">What does this look like from where you sit? <span class="opt">(optional)</span></label>
					<textarea id="note" [(ngModel)]="form.note" [ngModelOptions]="{standalone:true}"></textarea>
				</div>
				<div class="field">
					<label for="project">Working on a project? Tell me the scope <span class="opt">(optional)</span></label>
					<textarea id="project" [(ngModel)]="form.project" [ngModelOptions]="{standalone:true}"></textarea>
				</div>
				<div class="field check-field">
					<label class="check-row"><input type="checkbox" [(ngModel)]="form.wantsCall" [ngModelOptions]="{standalone:true}" /> <span>I would like a phone planning session to scope the work.</span></label>
				</div>
				<div class="field">
					<label>Which reports would you like?</label>
					<div class="reports-pick" id="reportsPick">
						<label class="opt-row" *ngFor="let r of content?.reports" [class.dim]="!isAvailable(r)">
							<input type="checkbox" [(ngModel)]="selected[r.title]" [ngModelOptions]="{standalone:true}" />
							<span class="rtext"><span class="rt">{{ r.title }}</span><span class="rd">{{ isAvailable(r) ? 'Available now' : 'Coming soon. Request early access.' }}</span></span>
						</label>
					</div>
					<p class="privacy" *ngIf="repError" style="color:var(--crimson)">Choose at least one report, or pick a service above.</p>
				</div>
				<div>



					<!--Kent-->
					<!--<button class="btn" type="submit" [disabled]="sending">{{ sending ? 'Sending...' : 'Request the report' }}</button>-->
					<!--<button class="btn" type="submit" [disabled]="sending || f.invalid">
		{{ sending ? 'Sending...' : 'Request the report' }}
	</button>-->
					<!--<button type="submit" class="btn" (click)="submit(f)">-->
					<button type="submit" class="btn">
						{{ sending ? 'Sending...' : 'Request the report' }}
					</button>


				</div>
				<p class="privacy">Your details are used to send the report and to continue the conversation. Nothing more.</p>
			</form>

			<div class="success" id="successMsg" *ngIf="submitted" style="display:block" role="status">
				<h3>Request received</h3>
				<p>Thank you. If you shared a project, I will follow up with you directly. What does this look like from where you sit?</p>
				<div class="downloads">

					<!--PDF-->
					<span *ngFor="let d of result?.downloads">
						<a class="btn" [href]="d.url" download (click)="analytics.track('report_download', d.title)">Download {{d.title}} report</a>
						<!--HTML-->
						<br />
						<a href="{{ d.url.replace('.pdf', '.html') }}" target="_blank">Browse {{d.title}} report</a>
					</span>

					<p class="soon-note" *ngFor="let t of result?.pending">{{ t }} is in production. I will let you know the moment it is ready.</p>
					<div class="donate-prompt" *ngIf="content?.stripe?.donate as donateUrl">
						Found this useful? You can <a [href]="donateUrl" target="_blank" rel="noopener">support the work</a>. The reports stay free either way.
					</div>
					<div class="schedule-prompt" *ngIf="result?.planningCall">
						<ng-container *ngIf="result?.booking as booking; else noBooking">
							You asked for a phone planning session. <a class="btn" [href]="booking" target="_blank" rel="noopener">Schedule your planning call</a>
						</ng-container>
						<ng-template #noBooking>You asked for a phone planning session. I will reach out to set a time that works for you.</ng-template>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<footer>
	<div class="wrap">
		<div class="wm">The <span>Energy</span> Professor</div>
		<div class="tag">Power and Infrastructure Intelligence</div>
		<p class="boiler">Infrastructure commercialization is the work of moving land, power, equipment, capital and stakeholders into assets that are energized, operating and producing.</p>
		<div class="legal">
			<span>&copy; 2026 The Energy Professor. All Rights Reserved.</span>
		</div>
	</div>
</footer>
